/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missing_Dialogue_TitleInputs */

const en_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing Dialogue`)
};

const fr_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue manquant`)
};

const de_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlender Dialog`)
};

const it_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogo mancante`)
};

const ru_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсутствующий диалог`)
};

const es_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo faltante`)
};

const zh_cn2_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缺失对话`)
};

const ja_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会話がない`)
};

const hi_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद गायब है`)
};

const pt_pt2_missing_dialogue_title = /** @type {(inputs: Missing_Dialogue_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo Ausente`)
};

/**
* | output |
* | --- |
* | "Missing Dialogue" |
*
* @param {Missing_Dialogue_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const missing_dialogue_title = /** @type {((inputs?: Missing_Dialogue_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Dialogue_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_missing_dialogue_title(inputs)
	if (locale === "de") return de_missing_dialogue_title(inputs)
	if (locale === "it") return it_missing_dialogue_title(inputs)
	if (locale === "ru") return ru_missing_dialogue_title(inputs)
	if (locale === "es") return es_missing_dialogue_title(inputs)
	if (locale === "zh-CN") return zh_cn2_missing_dialogue_title(inputs)
	if (locale === "ja") return ja_missing_dialogue_title(inputs)
	if (locale === "hi") return hi_missing_dialogue_title(inputs)
	if (locale === "pt-PT") return pt_pt2_missing_dialogue_title(inputs)
	return en_missing_dialogue_title(inputs)
});